import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../constants/breakpoints";
import { colors } from "../../../constants/colors";

const styles = createUseStyles((theme) => ({
  modalContent: {
    margin: "22px 0 0 0",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    "& .form-check": {
      display: "flex",
      alignItems: "center",
      margin: "0px"  
    },
    "& .form-check-input": {
      width: "20px",
      height: "20px",
      marginTop: 0,
      "&:focus": {
        boxShadow: "none",
      },
    },
    "& .form-check-label": {
      cursor: "pointer"
    },
    "& .form-check-input:checked" : {
      outline: "1px solid " + theme.modal.backgroundColor,
      border: `6px solid ${theme.modal.selectedOption.backgroundColor}`,
      "&:hover": {
        borderColor: theme.modal.optionHover.backgroundColor,
      },
    },
    "& .form-check-input:not(:checked)" : {
      "&:hover": {
        border: "1px solid " + theme.modal.backgroundColor,
        backgroundColor: theme.modal.optionHover.backgroundColor + "!important",
      },
    },
    color: colors.grey,
    fontWeight: "500"
  },
  footerBtns: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "22px"
  },
  checkbox: {
    marginRight: "12px",
    cursor: "pointer"
  },
  generalRadioListModalStyle: {
    width: "400px",
    "& .modal-header": {
      padding: "24px",
      "& div": {
        height: "46px",
        padding: "10px",
        "& svg": {
          display: "flex"
        }
      },
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "32px",
        right: "32px"
      }
    },
    "& .modal-title": {
      padding: "0 24px"
    },
    "& .modal-body, .modal-footer": {
      padding: "14px 24px 18px"
    },
    "& .modal-footer>*": {
      margin: "0px"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto"
    }
  },
  colCancel:{
    padding:"0px",
    marginRight:"6px"
  },
  colChange:{
    padding:"0px",
    marginLeft:"6px"
  },
  cancelBtn: {
    extend: "footerBtns"
  },
  saveBtn: {
    extend: "footerBtns"
  }
}));

export default styles;